import React from 'react';
import { useIntl } from 'react-intl';
import { ProposalAIPrimaryButton } from './ProposalAIPrimaryButton';
import { AdditionalInfoAIPanel } from './AdditionalInfoAIPanel';
import { useAdditionalInfoAI } from '../hooks';

export const AdditionalInfoAI: React.FC = () => {
  const { formatMessage } = useIntl();
  const additionalInfoAI = useAdditionalInfoAI();

  if (!additionalInfoAI.shouldRender) {
    return null;
  }

  return (
    <div className="proposal-additional-info-ai">
      {!additionalInfoAI.isOpen ? (
        <ProposalAIPrimaryButton
          label={formatMessage({ id: 'proposal-ai.additional-info.open' })}
          onClick={additionalInfoAI.handleOpen}
          btnSelector="proposal-ai-additional-info-open"
          style="outline"
          size="med"
          className="proposal-additional-info-ai__trigger"
        />
      ) : (
        <AdditionalInfoAIPanel
          prompt={additionalInfoAI.prompt}
          generated={additionalInfoAI.generated}
          isGenerating={additionalInfoAI.isGenerating}
          isGeneratedStale={additionalInfoAI.isGeneratedStale}
          onPromptChange={additionalInfoAI.setPrompt}
          onGenerate={additionalInfoAI.handleGenerate}
          onApply={additionalInfoAI.handleApply}
          onCancel={additionalInfoAI.resetState}
        />
      )}
    </div>
  );
};
